module.exports = __webpack_public_path__ + "img/doha.18eacf34.jpg";